import { render, staticRenderFns } from "./contactStatus.vue?vue&type=template&id=2e5ec485&scoped=true"
import script from "./contactStatus.vue?vue&type=script&lang=js"
export * from "./contactStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ec485",
  null
  
)

export default component.exports